import { Component } from '@angular/core';
import { LoaderService } from '../../../services/general/loader.service';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  isLoading = false;
  loaded = false;

  constructor(private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.loaderService.loading$.subscribe(isLoading => {
      this.isLoading = isLoading.loading;
      this.loaded = isLoading.loaded;
    });
  }
}
